export const formatPhoneNumber = (phone: string): string => {
  try {
    if (!phone) return '';

    const splitLength = Math.ceil((phone.length - 5) / 4);
    const splitArray = [
      phone.substring(0, 2),
      phone.substring(2, 5),
      ...new Array(splitLength)
        .fill(4)
        .map((_, idx) => phone.substring(5 + 4 * idx, 5 + 4 * (idx + 1))),
    ];

    return `${splitArray.join('-')}`;
  } catch (e) {
    return phone;
  }
};

export const formatCensorPhoneNumber = (phone: string): string => {
  if (!phone) return '';

  return `${phone.substring(0, 2)} ${phone.substring(
    2,
    4,
  )}******${phone.substring(phone.length - 3, phone.length)}
  `;
};
